import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useLocation } from 'react-router-dom';

const PreviousLocationContext = createContext(null);

export const PreviousLocationProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const location = useLocation();
  const prevLocationRef = useRef<string | null>(null);

  useEffect(() => {
    prevLocationRef.current = location.pathname;
  }, [location]);

  return (
    <PreviousLocationContext.Provider value={prevLocationRef.current}>
      {children}
    </PreviousLocationContext.Provider>
  );
};

export const usePreviousLocationContext = () =>
  useContext(PreviousLocationContext);
